import Localization, { TrustedValue } from 'lib/localization';

export default {
  get lxPageAboutHeroBlockTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.about.one.block.title');
  },

  get lxPageAboutHeroBlockText() {
    return Localization.get('bumblesite@rebrand.2024.page.about.one.block.text');
  },

  get lxPageAboutTwoBlockTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.about.two.block.title');
  },

  get lxPageAboutTwoBlockOneItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.about.two.block.item.one.title');
  },

  get lxPageAboutTwoBlockOneItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.about.two.block.item.one.text');
  },

  get lxPageAboutTwoBlockTwoItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.about.two.block.item.two.title');
  },

  get lxPageAboutTwoBlockTwoItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.about.two.block.item.two.text');
  },

  get lxPageAboutTwoBlockThreeItemTitle() {
    return Localization.get('bumblesite@rebrand.2024.page.about.two.block.item.three.title');
  },

  get lxPageAboutTwoBlockThreeItemText() {
    return Localization.get('bumblesite@rebrand.2024.page.about.two.block.item.three.text');
  },

  /* Project Love start */
  get lxPageLoveStoriesTitle() {
    return Localization.get('bumblesite@hero.love_stories');
  },

  get lxPageAboutHeroTitle() {
    return Localization.get('bumblesite@page.about.hero.title');
  },

  get lxPageAboutHeroDescription() {
    return Localization.get('bumblesite@page.about.hero.description');
  },

  get lxPageAboutHeroAlt() {
    return Localization.get('bumblesite@page.about.hero.alt');
  },

  lxPageAboutIntroTitle(year: number) {
    return Localization.get('bumblesite@page.about.intro.title', { date: year });
  },

  get lxPageAboutIntroDescription() {
    return Localization.get('bumblesite@page.about.intro.description');
  },

  get lxPageAboutIntroAlt() {
    return Localization.get('bumblesite@page.about.intro.alt');
  },

  get lxPageAboutCeoTitle() {
    return Localization.get('bumblesite@page.about.ceo.title');
  },

  get lxPageAboutCeoDescription() {
    return Localization.get('bumblesite@page.about.ceo.description', {
      __EOL__: TrustedValue.for('<br/>'),
    });
  },

  get lxPageAboutCeoAlt() {
    return Localization.get('bumblesite@page.about.ceo.alt');
  },

  get lxPageAboutOurStoryTitle() {
    return Localization.get('bumblesite@page.about.our_story.title');
  },

  get lxPageAboutOurStoryDescription() {
    return Localization.get('bumblesite@page.about.our_story.description');
  },

  get lxPageAboutOurStoryScrollText() {
    return Localization.get('bumblesite@page.about.our_story.scroll');
  },

  get lxPageAboutOurStoryScrollRightText() {
    return Localization.get('bumblesite@page.about.our_story.scroll_right');
  },

  get lxPageAboutOurStoryScrollLeftText() {
    return Localization.get('bumblesite@page.about.our_story.scroll_left');
  },

  get lxPageAboutOurStoryCard1Title() {
    return Localization.get('bumblesite@page.about.our_story.card1.title');
  },

  get lxPageAboutOurStoryCard1Description() {
    return Localization.get('bumblesite@page.about.our_story.card1.description');
  },

  get lxPageAboutOurStoryCard2Title() {
    return Localization.get('bumblesite@page.about.our_story.card2.title');
  },

  get lxPageAboutOurStoryCard2Description() {
    return Localization.get('bumblesite@page.about.our_story.card2.description', {
      bff: 'BFF',
    });
  },

  get lxPageAboutOurStoryCard3Title() {
    return Localization.get('bumblesite@page.about.our_story.card3.title');
  },

  get lxPageAboutOurStoryCard3Description() {
    return Localization.get('bumblesite@page.about.our_story.card3.description');
  },

  get lxPageAboutOurStoryCard4Title() {
    return Localization.get('bumblesite@page.about.our_story.card4.title');
  },

  get lxPageAboutOurStoryCard4Description() {
    return Localization.get('bumblesite@page.about.our_story.card4.description');
  },

  get lxPageAboutOurStoryCard5Title() {
    return Localization.get('bumblesite@page.about.our_story.card5.title');
  },

  get lxPageAboutOurStoryCard5Description() {
    return Localization.get('bumblesite@page.about.our_story.card5.description');
  },

  get lxPageAboutOurStoryCard6Title() {
    return Localization.get('bumblesite@page.about.our_story.card6.title');
  },

  get lxPageAboutOurStoryCard6Description() {
    return Localization.get('bumblesite@page.about.our_story.card6.description');
  },

  get lxPageAboutOurStoryCard7Title() {
    return Localization.get('bumblesite@page.about.our_story.card7.title');
  },

  get lxPageAboutOurStoryCard7Description() {
    return Localization.get('bumblesite@page.about.our_story.card7.description');
  },

  get lxPageAboutOurStoryCard8Title() {
    return Localization.get('bumblesite@page.about.our_story.card8.title');
  },

  get lxPageAboutOurStoryCard8Description() {
    return Localization.get('bumblesite@page.about.our_story.card8.description');
  },

  get lxPageAboutMissionTitle() {
    return Localization.get('bumblesite@page.about.mission.title');
  },

  get lxPageAboutMissionStatement() {
    return Localization.get('bumblesite@page.about.mission.statement');
  },

  get lxPageAboutWorkWithUsTitle() {
    return Localization.get('bumblesite@page.about.work_with_us.title');
  },

  get lxPageAboutWorkWithUsDescription() {
    return Localization.get('bumblesite@page.about.work_with_us.description');
  },

  get lxPageAboutWorkWithUsCta() {
    return Localization.get('bumblesite@page.about.work_with_us.cta');
  },

  /* Project Love end */
};
